import styled from 'styled-components'

import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const Container = styled.div`
  padding: 30px 0;
  margin: 0 auto;
  width: 100%;
  text-align: center;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    padding 10px 0px 50px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding 30px 0;
  }
`

export const Title = styled(Heading2)`
  font-size: 16px;
  margin: 20px 0 6px;
`

export const Text = styled(Body)`
  margin: 0 auto 30px;
  max-width: 450px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
    max-width: 100%;
  }
`

export const Image = styled.img`
  max-width: 244px;
  width: 100%;
  margin: 0 auto;
  height: auto;
`
